
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <a href="#home" className="flex items-center space-x-2 cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-bear-smile-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-amber-500 to-amber-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
                Dog Store
              </span>
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <p className="text-gray-300 font-semibold mb-3">Мы в социальных сетях:</p>
            <div className="flex space-x-4">
              <a href="https://t.me/storedogmaltypoo" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center group">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                  <i className="ri-telegram-fill"></i>
                </div>
                <span className="text-xs text-gray-400 mt-1">Telegram</span>
              </a>
              <a href="https://vk.com/modnyipuppy" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center group">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                  <i className="ri-vk-fill"></i>
                </div>
                <span className="text-xs text-gray-400 mt-1">ВКонтакте</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer">
                  {t('footer.home')}
                </a>
              </li>
              <li>
                <a href="#puppies" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer">
                  {t('footer.availablePuppies')}
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer">
                  {t('footer.aboutUs')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer">
                  {t('footer.contact')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.ourBreeds')}</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">{t('footer.toyPoodles')}</li>
              <li className="text-gray-400">{t('footer.miniaturePoodles')}</li>
              <li className="text-gray-400">{t('footer.maltipoos')}</li>
              <li className="text-gray-400">{t('footer.championBloodlines')}</li>
              <li className="text-gray-400">{t('footer.healthCertified')}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.contactInfo')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0"></i>
                <span>{t('footer.locationCity')}</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                <span>+7 927 955 09 50</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                <span>+7 965 939 87 77</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                <span>23spoon@mail.ru</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-time-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                <span>{t('footer.schedule')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                {t('footer.privacyPolicy')}
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                {t('footer.termsOfService')}
              </a>
              <a href="https://doggstore.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                {t('footer.websiteBuilder')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
